import { Typography, Paper } from "@mui/material";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const reportData = [
  { name: "Jan", revenue: 5000, labTests: 50 },
  { name: "Feb", revenue: 7000, labTests: 70 },
  { name: "Mar", revenue: 6000, labTests: 60 },
  { name: "Apr", revenue: 8000, labTests: 80 },
];

export default function Reports() {
  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h4" color="primary" gutterBottom>
        Reports
      </Typography>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={reportData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="revenue" fill="#1976d2" />
          <Bar dataKey="labTests" fill="#4caf50" />
        </BarChart>
      </ResponsiveContainer>
    </Paper>
  );
}
